import * as Yup from "yup";

const CustomerLocationSchema = Yup.object({
  name: Yup.string().required("INPUT.VALIDATION.ADDRESS.LOCATIONNAME"),
  address: Yup.object({
    regionId: Yup.string().required("INPUT.VALIDATION.REGION"),
    address_line_1: Yup.string().required(
      "INPUT.VALIDATION.ADDRESS.ADDRESS.LINE1",
    ),
    city: Yup.string().required("INPUT.VALIDATION.ADDRESS.ADDRESS.CITY"),
    postal: Yup.string().required("INPUT.VALIDATION.ADDRESS.ADDRESS.ZIPCODE"),
  }),
  remarks: Yup.string(),
});
export default CustomerLocationSchema;
